import 'rxjs/add/operator/debounceTime';
import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TAction, TConsumoFlag, THotspotFlag, THotspotList} from "../../../app/enum";
import {TFieldType, TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {WebstorService} from "../../../providers/webstor-service";
import {ModalFieldPage} from "../modal-field/modal-field";
import {Observable} from "rxjs";

@Component({
    selector: 'page-webstor-open',
    templateUrl: 'webstor-open.html',
    providers: [WebstorService]
})
export class WebstorOpenPage {

    config: any;
    logado: any;
    perfil: any;



    keyname: 'Assunto' | 'Hashtag' | 'Negocio' | 'Departa' | 'Deposit' | 'Escolha' | 'Esconde' | 'Projeto' | 'Package' | 'Ambient' | 'Praceta' | 'Justify';
    toggler: 'ball' | 'hide' | 'line' | 'many' | null;

    rootctrl: any;
    itemctrl: any;

    homeb: boolean;
    etapa: number;
    title: string;
    _count: number = 5;

    rootspot: any;
    monitorBool: boolean;

    consumoFlag: TConsumoFlag;

    akkjson = (window as any).handappMainInstance.appjson;

    constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams,
                public util: Util,
                public logadoService: LogadoService, public webstorService: WebstorService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.perfil = this.navParams.get('perfil');

        this.rootspot = this.navParams.get('rootspot');

        this.itemctrl = this.navParams.get('itemctrl');
        this.rootctrl = this.navParams.get('rootctrl');

        this.homeb = this.navParams.get('homeb');
        this.etapa = this.navParams.get('etapa');
        this.title = this.navParams.get('title');

        this.keyname = this.navParams.get('keyname');
        this.toggler = this.util.anyParams(null, this.navParams.get('toggler'));
        
        this.monitorBool = this.util.anyParams(false, this.navParams.get('monitorBool'));
        this.consumoFlag = this.util.anyParams(TConsumoFlag.cfTudo, this.navParams.get('consumoFlag'));

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Webstor Open', '/webstor-open');

        if (!this.rootctrl) this.controlLoad();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle(): string {

        if (this.title)    return this.title;
        if (this.itemctrl) return this.controlNome(this.itemctrl);

        return this.keyname;

    }

    controlID(control) {

        if (this.keyname == 'Assunto') return control.AssuntoID;
        if (this.keyname == 'Hashtag') return control.HashtagID;
        if (this.keyname == 'Negocio') return control.NegocioID;
        if (this.keyname == 'Departa') return control.DepartaID;
        if (this.keyname == 'Deposit') return control.DepositID;
        if (this.keyname == 'Escolha') return control.EscolhaID;
        if (this.keyname == 'Esconde') return control.EscondeID;
        if (this.keyname == 'Projeto') return control.ProjetoID;
        if (this.keyname == 'Package') return control.PackageID;
        if (this.keyname == 'Ambient') return control.AmbientID;
        if (this.keyname == 'Praceta') return control.PracetaID;
        if (this.keyname == 'Justify') return control.JustifyID;

    }

    controlNome(control) {

        if (this.keyname == 'Assunto') return control.AssuntoNome;
        if (this.keyname == 'Hashtag') return control.HashtagNome;
        if (this.keyname == 'Negocio') return control.NegocioNome;
        if (this.keyname == 'Departa') return control.DepartaNome;
        if (this.keyname == 'Deposit') return control.DepositNome;
        if (this.keyname == 'Escolha') return control.EscolhaNome;
        if (this.keyname == 'Esconde') return control.EscondeNome;
        if (this.keyname == 'Projeto') return control.ProjetoNome;
        if (this.keyname == 'Package') return control.PackageNome;
        if (this.keyname == 'Ambient') return control.AmbientNome;
        if (this.keyname == 'Praceta') return control.PracetaNome;
        if (this.keyname == 'Justify') return control.JustifyNome;

    }

    controlIcon(control) {

        if (this.keyname == 'Assunto') return control.AssuntoIcon;
        if (this.keyname == 'Hashtag') return control.HashtagIcon;
        if (this.keyname == 'Negocio') return control.NegocioIcon;
        if (this.keyname == 'Departa') return control.DepartaIcon;
        if (this.keyname == 'Deposit') return control.DepositIcon;
        if (this.keyname == 'Escolha') return control.EscolhaIcon;
        if (this.keyname == 'Esconde') return control.EscondeIcon;
        if (this.keyname == 'Projeto') return control.ProjetoIcon;
        if (this.keyname == 'Package') return control.PackageIcon;
        if (this.keyname == 'Ambient') return control.AmbientIcon;
        if (this.keyname == 'Praceta') return control.PracetaIcon;
        if (this.keyname == 'Justify') return control.JustifyIcon;

    }

    controlList(control):any[] {

        if (this.keyname == 'Assunto') return control.Assuntos.filter((CTRL, IN) => IN <= (control._count || this._count)-1);
        if (this.keyname == 'Hashtag') return control.Hashtags.filter((CTRL, IN) => IN <= (control._count || this._count)-1);
        if (this.keyname == 'Negocio') return control.Negocios.filter((CTRL, IN) => IN <= (control._count || this._count)-1);
        if (this.keyname == 'Departa') return control.Departas.filter((CTRL, IN) => IN <= (control._count || this._count)-1);
        if (this.keyname == 'Deposit') return control.Deposits.filter((CTRL, IN) => IN <= (control._count || this._count)-1);
        if (this.keyname == 'Escolha') return control.Escolhas.filter((CTRL, IN) => IN <= (control._count || this._count)-1);
        if (this.keyname == 'Esconde') return control.Escondes.filter((CTRL, IN) => IN <= (control._count || this._count)-1);
        if (this.keyname == 'Projeto') return control.Projetos.filter((CTRL, IN) => IN <= (control._count || this._count)-1);
        if (this.keyname == 'Package') return control.Packages.filter((CTRL, IN) => IN <= (control._count || this._count)-1);
        if (this.keyname == 'Ambient') return control.Ambients.filter((CTRL, IN) => IN <= (control._count || this._count)-1);
        if (this.keyname == 'Praceta') return control.Pracetas.filter((CTRL, IN) => IN <= (control._count || this._count)-1);
        if (this.keyname == 'Justify') return control.Justifys.filter((CTRL, IN) => IN <= (control._count || this._count)-1);

        return [];

    }

    controlDown(control, tipo: 'qtde' | 'click' | 'press') {

        if (tipo == 'qtde') {
            if (this.keyname == 'Assunto') return control.Assuntos.length > (control._count || this._count);
            if (this.keyname == 'Hashtag') return control.Hashtags.length > (control._count || this._count);
            if (this.keyname == 'Negocio') return control.Negocios.length > (control._count || this._count);
            if (this.keyname == 'Departa') return control.Departas.length > (control._count || this._count);
            if (this.keyname == 'Deposit') return control.Deposits.length > (control._count || this._count);
            if (this.keyname == 'Escolha') return control.Escolhas.length > (control._count || this._count);
            if (this.keyname == 'Esconde') return control.Escondes.length > (control._count || this._count);
            if (this.keyname == 'Projeto') return control.Projetos.length > (control._count || this._count);
            if (this.keyname == 'Package') return control.Packages.length > (control._count || this._count);
            if (this.keyname == 'Ambient') return control.Ambients.length > (control._count || this._count);
            if (this.keyname == 'Praceta') return control.Pracetas.length > (control._count || this._count);
            if (this.keyname == 'Justify') return control.Justifys.length > (control._count || this._count);
        }

        if (tipo != 'qtde') {
            let press = (tipo == 'press');
            let tables = this.keyname + 's';

            let count = control[tables].length;
            let somar = (control._count || this._count) + this._count;
            control._count = (press ? count : somar);
            if (press) this.util.impact();
        }

    }

    controlSort():any[] {

        let tables = this.keyname + 's';
        if (this.itemctrl) return this.itemctrl[tables];
        if (this.rootctrl) return this.rootctrl;

        return [];

    }

    controlCate(control) {

        let nome = this.keyname + 'Nome';
        let tables = this.keyname + 's';

        return this.util.jsCat(control[tables], [nome]);

    }

    controlKeep(control) {

        if (this.keyname == 'Esconde' && this.toggler == 'many') {
            let action = (control._selected ? TAction.acShow : TAction.acHide);
            this.webstorService.esconde(action, this.rootspot.Hotspots[0].HotspotID, control.EscondeID)
                .subscribe(
                    //data => ,
                    erro => this.util.alertResult(erro)
                );
            return;
        }

        if (this.toggler != 'hide' && this.toggler != 'line') return;

        let tables = this.keyname + 's';
        this.rootctrl.forEach(C1 => {
            C1[tables].forEach(C2 => {
               if (C2 != control) C2._selected = false;
            });
        });

        if (this.toggler == 'hide') {
            control._selected = true;
            this.dismiss();
        }

    }

    controlBall(control) {

        let object = {homeb: false, etapa: 0, keyname: this.keyname, toggler: this.toggler, title: this.title, itemctrl: control, rootctrl: this.rootctrl};
        this.util.modalopen(WebstorOpenPage, 'quad', true, object).subscribe(data => {

            if (data === true) this.dismiss(control);
            if (data !== true) this.dismiss(data);

        });

    }

    controlLine(control, contrul) {

        if (this.homeb) {
            this.controlEdit(contrul);
            return;
        }

        this.dismiss(contrul);

    }

    controlCria(control, contrul) {

    }

    controlData(data) {

        if (this.keyname == 'Esconde') {
            data.Escondes.forEach(ES => {
                ES.Escondes.forEach(EC => EC._selected = !EC.EscondeHide);
            });
        }

        let tables = this.keyname + 's';
        let codeid = this.keyname + 'ID';
        let array = data[tables];


        if (this.itemctrl) this.itemctrl = array.find(C1 => C1[codeid] == this.itemctrl[codeid]);


        if (!this.homeb && this.rootspot) {
            data[tables].forEach(DT => {
                for (let i = DT[tables].length-1; i >= 0; i = i - 1) {
                    let branded = DT[tables][i].Branded;
                    let brandeh = this.rootspot.Hotspots[0].Branded;
                    let deleted = (branded && branded.BrandedID != brandeh.BrandedID);
                    if (deleted) DT[tables].splice(i, 1);
                }
            });

            array = data[tables].filter(DT => DT[tables].length);
        }

        if (this.rootspot) {
            let codes = [];
            if (this.keyname == 'Deposit' && this.rootspot.Hotspots[0].Deposit) codes.push(this.rootspot.Hotspots[0].Deposit.DepositID);

            array.forEach(C1 => {
                C1[tables].forEach(C2 => {
                    if (codes.findIndex(CD => CD == C2[codeid]) >= 0) C2._selected = true;
                });
            });
        }

        this.rootctrl = array;

    }

    controlLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        let observ: Observable<any> = null;
        if (this.keyname == 'Assunto') observ = this.webstorService.assunto(TAction.acLoad);
        if (this.keyname == 'Hashtag') observ = this.webstorService.hashtag(TAction.acLoad);
        if (this.keyname == 'Negocio') observ = this.webstorService.negocio(TAction.acLoad);
        if (this.keyname == 'Departa') observ = this.webstorService.departa(TAction.acLoad);
        if (this.keyname == 'Deposit') observ = this.webstorService.deposit(TAction.acLoad);
        if (this.keyname == 'Escolha') observ = this.webstorService.escolha(TAction.acLoad);
        if (this.keyname == 'Esconde') observ = this.webstorService.esconde(TAction.acLoad, this.rootspot.Hotspots[0].HotspotID);
        if (this.keyname == 'Projeto') observ = this.webstorService.projeto(TAction.acLoad);
        if (this.keyname == 'Package') observ = this.webstorService.package(TAction.acLoad);
        if (this.keyname == 'Ambient') observ = this.webstorService.ambient(TAction.acLoad);
        if (this.keyname == 'Praceta') observ = this.webstorService.praceta(TAction.acLoad);
        if (this.keyname == 'Justify' && !this.monitorBool) observ = this.webstorService.justify(TAction.acLoad, null, this.consumoFlag);
        if (this.keyname == 'Justify' &&  this.monitorBool) observ = this.util.monitorDesk(true, 'DESK-Justify', 0, '&ConsumoFlag=' + this.consumoFlag, TAction.acLoad)


        observ
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.controlData(data),
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    controlSave(that, control) {

        let loading = this.util.loadingDots();
        loading.present();


        let observ: Observable<any> = null;
        let json = {tables: [this.rootctrl]};
        if (this.keyname == 'Assunto') observ = this.webstorService.assunto(TAction.acSave, json);
        if (this.keyname == 'Hashtag') observ = this.webstorService.hashtag(TAction.acSave, json);
        if (this.keyname == 'Negocio') observ = this.webstorService.negocio(TAction.acSave, 0, 0, 0, THotspotList.hlNegocio, THotspotFlag.hfHotspotNenhum, json);
        if (this.keyname == 'Departa') observ = this.webstorService.departa(TAction.acSave, json);
        if (this.keyname == 'Deposit') observ = this.webstorService.deposit(TAction.acSave, 0, 0, json);
        if (this.keyname == 'Escolha') observ = this.webstorService.escolha(TAction.acSave, 0, json);
      //if (this.keyname == 'Esconde') observ = this.webstorService.esconde(TAction.acHide, 0, json);
        if (this.keyname == 'Projeto') observ = this.webstorService.projeto(TAction.acSave, json);
        if (this.keyname == 'Package') observ = this.webstorService.package(TAction.acSave, 0, json);
        if (this.keyname == 'Ambient') observ = this.webstorService.ambient(TAction.acSave, 0, 0, json);
        if (this.keyname == 'Praceta') observ = this.webstorService.praceta(TAction.acSave, 0, 0, json);
        if (this.keyname == 'Justify') observ = this.webstorService.justify(TAction.acSave, json);


        observ
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.controlData(data),
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    controlEdit(line, array: Array<any> = null, arrayName: string = '', $event: any = null) {

        if ($event) event.stopPropagation();

        let exist = !!line;
        if (!exist) {
            line = {DepositID: 0, DepositNome: ''};
            if (arrayName) line[arrayName] = [];
        }

        let onOkiy = (that, okiy, index, isLast) => {
            if (this.util.slideNext(that, !isLast)) return;
            if (!exist) array.push(line);

            line.DepositNome = okiy[0].groups[0].fields[0].value;
            that.dismiss(); //this.controlSave(that, line);
        };


        /** SLIDE 01 **/
        let fieldNome = this.config.modalField(TFieldType.ftLine, 'Nome do Depósito', null, null, this.controlNome(line), null, null);
        let groupNome = this.config.modalGroup(null, [fieldNome]);
        let slideNome = this.config.modalSlide('Info', null, null, null, 'CorRoxa', [groupNome]);
        this.util.modalopen(ModalFieldPage, 'wide', false, {slides: [slideNome], onOkiy: onOkiy}).subscribe();

    }

    orderbyMove(indexes, dismiss: boolean = false) {
/*
        // o primeiro é o botão de adicionar
        if (indexes && indexes.from && indexes.to) {
            let from = indexes.from -1;
            let toto = indexes.to -1;

            let item = this.change[from];
            this.change.splice(from, 1);
            this.change.splice(toto, 0, item);

            if (toto == this.change[this.selected].Value.length - 1) {
                //
            }
        }

        this.controlSave(TAction.acMove);
*/
    }








/*

    negocioClick(indtwo: number, baseb: boolean = false, cargo: 'NAO' | 'SIM' | 'OPEN' = 'NAO') {

        let newetapa = (cargo == 'NAO' ? 2 : 3);

        if (!this.homeb) {
            let level2 = this.copycios[this.indone].Negocios[indtwo];
            if (!level2.Workways.length) newetapa = 1;
        }

        if (this.homeb && cargo == 'OPEN') {

             OPEN
            let buttons: Array<any> = [];
            buttons.push({text: 'Hashtag', handler: () => this.negocioClick(indtwo, baseb, 'NAO')});
            buttons.push({text: 'Cargo',   handler: () => this.negocioClick(indtwo, baseb, 'SIM')});
            this.util.sheetOpen(buttons, 'SELECT');

            return;
        }

        this.baseb = baseb;
        this.indtwo = indtwo;
        this.etapa = newetapa;

        if (this.etapa == 1) this.finaliza();

    }

    selected(workway, workwey) {

        if (this.homeb) {
            this.grupoadd(workwey);
            return;
        }

        workwey.selected = !workwey.selected;

    }

    finaliza() {

        if (!this.baseb) {

            let works = [];

            let level2 = this.copycios[this.indone].Negocios[this.indtwo];
            level2.Workways.forEach(way => {
                let array = way.Workweys.filter(wey => (wey.selected));
                if (array.length) {
                    way.Workweys = array;
                    works.push(way);
                }
            });

            let result = this.copycios[this.indone].Negocios[this.indtwo];
            result.NegocioWorks = works;
            this.dismiss(result);
            return;
       }

    }




*/


    dismiss(result?) {
        
        if (!result && this.rootctrl) {
            result = [];
            let tables = this.keyname + 's';
            this.rootctrl.forEach(C1 => {
                C1[tables].forEach(C2 => {
                    if (C2._selected) result.push(C2);
                });
            });
            if (!result.length) result = null;
        }

        if (result && this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss(result);
            this.util.statusBarColor(TStatusBar.sbStyleLightContent);
            return;
        }

        this.navCtrl.pop();
        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/webstor-open/webstor-open.ts